import React from 'react';

const StatsError = ({ message }) => {
  return (
    <div className="bg-crystal-white border-l-3 border-error shadow-minimal">
      <div className="p-6">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0 mt-1">
            <svg className="h-5 w-5 text-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 15.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <div className="flex-1">
            <p className="text-sm font-medium text-graphite leading-relaxed">{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsError;
